import styles from './FilterBox.module.scss'
import React from 'react'

type Props = {
  children: React.ReactNode
}

const FilterBox = (props: Props) => {
  return (
    <div className={styles.component}>
      {props.children}
    </div>
  )
}

export default FilterBox